module.exports = __webpack_public_path__ + "static/media/mikio.22671dbe.jpg";